<template>
    <v-img cover 
        v-if="item.HeaderImage || item.NiveaImage" 
        :alt="item.NiveaAltText?item.NiveaAltText:item.AltText"
        :src="item.NiveaImage ? item.NiveaImage : item.HeaderImage" 
        :aspect-ratio="item.NiveaImage?'':1"
        :max-width="item.NiveaImage ? '' : 130"
    />    
</template>
<script setup>

const props = defineProps({
  item: {
    type: Object,
    default: [],
  },
});

</script>
